import { reactNativeWindow } from '../../utils/get-native-window';
import { RNAction } from './constants';

export const send2RN = (action: RNAction, data?: any) => {
  reactNativeWindow.ReactNativeWebView?.postMessage(
    JSON.stringify({
      action,
      data,
    })
  );
};
